

import Vue from 'vue';
import Component from "vue-class-component";
import {factory, PaymentRefundRequest} from "@/api-client";
import {Prop} from "vue-property-decorator";
import {BModal} from "bootstrap-vue";

@Component({})
export default class RefundPaymentModal extends Vue {
  @Prop({required: true})
  refundPaymentAction!: (paymentRefundRequest: PaymentRefundRequest) => Promise<void>;
  
  paymentRefundRequest: PaymentRefundRequest = factory.create(PaymentRefundRequest);

  $refs!: {refundbModal: BModal}

  public async show() {
    this.$refs.refundbModal.show();
  }

  cancel() {
    this.$refs.refundbModal.hide();
    this.paymentRefundRequest.comment = "";
    this.paymentRefundRequest.refundedAt = null;
  }
  
  async refundPayment() {
    this.$refs.refundbModal.hide(); // NOTE: This has to be before awaiting callback.
    await this.refundPaymentAction(this.paymentRefundRequest);
  }
  
  get canSubmit(): boolean {
    return this.paymentRefundRequest.comment != null 
        && this.paymentRefundRequest.comment.length > 0
        && this.paymentRefundRequest.refundedAt != null;
  }
}
